import React, { useState } from 'react';
import { Container, Row, Col, Alert, Form, Button, Badge, ListGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import * as yup from 'yup';
import { Formik } from 'formik';

// import { useAuth } from 'Context/auth';
import { useUserStore } from 'Store/userStore';
import DynamicBeadCrumbs from 'Components/Shared/DynamicBreadCrumbs';
import UserService from 'Services/UserService';
import { upperCaseThis, capitalizeFstLetterOfThis } from 'Utils/Helpers';

const schema = yup.object({
    OldPassword: yup.string().required(),
    Password: yup.string().min(3).required(),
    ConfirmPassword: yup
        .string()
        .oneOf([yup.ref('Password'), null], 'Passwords must match')
        .min(3)
        .required(),
});

const PasswordChange = () => {
    // const { user } = useAuth();
    const user = useUserStore((state) => state.user);

    const history = useHistory();
    const [error, setError] = useState(null);

    const submitForm = async (formValues) => {
        try {
            setError(null);
            const { status } = await UserService.passwordUpdate(formValues);
            if (status === 200) {
                toast.success('Votre mot de passe à été changé avec succès');
                history.replace('/apps');
            } else throw new Error();
        } catch (err) {
            const {
                response: {
                    data: { message },
                },
            } = err;
            setError(message || 'Error occured!');
        }
    };

    return (
        <Container>
            <DynamicBeadCrumbs
                items={[
                    {
                        link: '/',
                        name: 'Home',
                    },
                    {
                        name: 'Profile',
                        active: true,
                    },
                ]}
            />
            <Row>
                <Col xs={12} md="6">
                    <Row className="profile">
                        <Col>
                            <div className="profile-userpic text-center">
                                <img src="/images/default_user_avatar.png" className="img-responsive" alt="" />
                            </div>
                            <div className="profile-usertitle">
                                <div className="profile-usertitle-name">
                                    {capitalizeFstLetterOfThis(user.FirstName)} {upperCaseThis(user.LastName)}
                                </div>
                                <div className="profile-usertitle-job">@{user ? user.UserName : '-'}</div>
                            </div>
                            <div className="profile-userbuttons">
                                <Badge style={{ backgroundColor: '#1f70b8', color: '#fff' }}>
                                    {user ? user.userData.fonction.name : '-'}
                                </Badge>
                                {user &&
                                    user.userData.fonction.group &&
                                    user.userData.fonction.group.name !== user.userData.fonction.name && (
                                        <>
                                            &nbsp;
                                            <Badge style={{ backgroundColor: '#69be56', color: '#fff' }}>
                                                {user ? user.userData.fonction.group.name : '-'}
                                            </Badge>
                                        </>
                                    )}
                                {user && user.userData.fonction.projet && (
                                    <>
                                        &nbsp;
                                        <Badge style={{ backgroundColor: '#7c7c7d', color: '#fff' }}>
                                            {user ? user.userData.fonction.projet.name : '-'}
                                        </Badge>
                                    </>
                                )}
                            </div>
                            <div className="mt-3">
                                <ListGroup>
                                    <ListGroup.Item className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <FontAwesomeIcon size="lg" color="#1f70b8" icon={faEnvelope} /> Email :
                                        </div>
                                        <div>{user ? user.Email : '-'}</div>
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} md="6">
                    <div className="text-center py-3 mt-3">
                        <h2 className="mb-0">Changement de mot de passe</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                    </div>
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            OldPassword: '',
                            Password: '',
                            ConfirmPassword: '',
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="exampleForm.ControlOldPassword">
                                    <Form.Label>Ancien mot de passe</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Ancien mot de passe"
                                        name="OldPassword"
                                        value={values.OldPassword}
                                        onChange={handleChange}
                                        isInvalid={!!errors.OldPassword}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.OldPassword}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlPassword">
                                    <Form.Label>Nouveau mot de passe</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Nouveau mot de passe"
                                        name="Password"
                                        value={values.Password}
                                        onChange={handleChange}
                                        isInvalid={!!errors.Password}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.Password}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlConfirmPassword">
                                    <Form.Label>Confirmer votre mot de passe</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Confirmer votre mot de passe"
                                        name="ConfirmPassword"
                                        value={values.ConfirmPassword}
                                        onChange={handleChange}
                                        isInvalid={!!errors.ConfirmPassword}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.ConfirmPassword}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button variant="primary" type="submit" block>
                                    Enregistrer
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </Container>
    );
};

export default PasswordChange;
